import React from 'react';
import ReactDOM from 'react-dom';
import Loader from './Loader.jsx';
import { connect } from 'react-redux';
import loadScript from 'load-script';
import enetpulseConfig from '../config/enetpulse.json';

const loadCss = href => {
  const cssId = 'enetpulse-css';
  if (!document.getElementById(cssId)) {
    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    link.id = cssId;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = href;
    link.media = 'all';
    head.appendChild(link);
  }
};

const mapStateToProps = state => ({
  country: state.country,
});

@connect(mapStateToProps)
export default class EnetpulseWidget extends React.PureComponent {
  static propTypes = {
    widgetType: React.PropTypes.string,
    params: React.PropTypes.string,
    className: React.PropTypes.string,
    sport: React.PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = { showLoadingSpinner: false };
  }

  componentDidMount() {
    this.setState({showLoadingSpinner: true}, () => { // eslint-disable-line react/no-did-mount-set-state
      //window.mx_user_settings = enetpulseConfig[this.props.country];
       window.mx_user_settings = enetpulseConfig['dk'];
      loadScript('https://https-tv3sport-mx-api.enetscores.com/xjs/hour/theme/mx/555/front');
      loadCss('https://https-tv3sport-mx-api.enetscores.com/hour/gz/css/mx/555.css');

      if (window.mx) window.mx.snippet_autoload(ReactDOM.findDOMNode(this.refs.widget), 'self');
    });
  }

  render() {
    const { widgetType, params, className, sport } = this.props;

    return (
      <div className="enetpulse-widget">
        { this.state.showLoadingSpinner && <Loader /> }
        <div ref="widget"
          className={`mx-load-snippet mx-ajax-snippet mx-inline-widget ${className}`}
          data-link-group={sport}
          data-snippet="page"
          data-params={`{"theme": "xhr", "title": "${widgetType}", "params": "${params}"}`}
        >
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/EnetpulseWidget.jsx